import { reduce, isNil } from 'lodash';
import * as History from 'history';

import { GetUrlParams } from '@tradingblock/api';
import { TradingBlockEnvironments } from '@tradingblock/types';
import { VirtualTradingPaths, config as Config, ConfigType } from './clientConfig';

export const toHashParams = (args: Record<string, any>) => {
  const combinedValues = reduce(
    args,
    (acc: string[], v: any, k: string) => {
      if (isNil(v)) {
        return acc;
      }
      return [...acc, `${k}=${v}`];
    },
    []
  ).join('&');
  return `#${combinedValues}`;
};

export const getEnvironment = (location: History.Location<any>): string => {
  const params = GetUrlParams(location.search);
  const environment = params['environment'] || undefined;

  if (environment) {
    return environment;
  } else if (
    Config.environment === TradingBlockEnvironments.virtual ||
    VirtualTradingPaths.includes(location.pathname)
  ) {
    return 'virtual';
  } else {
    return 'dashboard';
  }
};

export const getConfig = (env: string): ConfigType => {
  if (env === 'virtual') {
    return Config.virtual;
  }
  return Config.dashboard;
};
